var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 159,
    viewBox: "0 0 141 159",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 159,
    rx: 8,
    fill: "#FFEFE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 117H101C102.65 117 104 115.65 104 114V100.17C104 89.61 95.39 81 84.83 81H81.77C87.89 77.34 92 70.65 92 63C92 51.42 82.58 42 71 42C59.42 42 50 51.42 50 63C50 70.65 54.11 77.34 60.23 81H57.17C46.61 81 38 89.61 38 100.17V114C38 115.65 39.35 117 41 117ZM56 63C56 54.72 62.72 48 71 48C79.28 48 86 54.72 86 63C86 71.28 79.28 78 71 78C62.72 78 56 71.28 56 63ZM44 100.17C44 92.91 49.91 87 57.17 87H84.8C92.06 87 97.97 92.91 97.97 100.17V111H88.97V102C88.97 100.35 87.62 99 85.97 99C84.32 99 82.97 100.35 82.97 102V111H58.97V102C58.97 100.35 57.62 99 55.97 99C54.32 99 52.97 100.35 52.97 102V111H44V100.17Z",
    fill: "#FD6202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/maleIcon.7efaf0d2f7b69a335d2ab9bebb26aee8.svg";
export { ForwardRef as ReactComponent };